<div class="desktop-width-limiter page-padding detail-page">
  @if (!loading && !error && profile) {
  @let isSubscribed = (isSubscribed$ | async) ?? false;
  @let isStreapper = (isStreapper$ | async) ?? false;

    <div class="page-content">
      <banner [profile]="profile" [isSubscribed]="isSubscribed" />
      <div class="info">
        <div class="top-info">
          <div class="left-top-info col-12 col-sm-6 col-lg-4 col-xl-4 col-xxl-4 col-xxxl-4">
            <profile-userinfo-field
              class="user-info"
              [userInfo]="userProfile"
              [isSubscribed]="isSubscribed"
            />
            <my-subscriptions 
              class="subscription-info"
              [subscriptions]="subscriptions"
            />
          </div>
          <profile-location-field
            [userProfile$]="userProfile$"
            class="location-info col-12 col-sm-6 col-lg-4 col-xl-4 col-xxl-4 col-xxxl-4"
          />
          <div class="widgets col-12 col-lg-4 col-xl-4 col-xxl-4 col-xxxl-4">
            <div class="top row">
              <profile-widget
                [iconName]="'drafts'"
                [text]="'profile.widgets.contact_admin' | translate"
                [backgroundType]="'white'"
                (click)="contactAdmin()"
                style="padding-right: 5px"
                class="col-6"
              />
              <profile-widget
                [iconName]="'logout'"
                [text]="'profile.widgets.logout' | translate"
                [backgroundType]="'grey'"
                (click)="logout()"
                style="padding-left: 5px"
                class="col-6"
              />
            </div>
            <div class="bottom row">
              <profile-widget
                [iconName]="'share'"
                [text]="'profile.widgets.share' | translate"
                [backgroundType]="'white'"
                (click)="share()"
                style="padding-right: 5px"
                class="col-6"
              />
              <profile-widget
                [iconName]="'person_remove'"
                [text]="'profile.widgets.delete' | translate"
                [backgroundType]="'transparent'"
                (click)="deleteAccount()"
                style="padding-left: 5px"
                class="col-6"
              />
            </div>
          </div>
        </div>
        
        <div class="bottom-info">
          <about-me-field
            style="height: inherit"
            class="about-me col-12 col-lg-8 col-xl-8 col-xxl-8 col-xxxl-8"
            [description]="profile.profile"
            [userInfo]="userProfile"
            [isStreapper]="isStreapper"
          />

          <div class="counters col-12 col-lg-4 col-xl-4 col-xxl-4 col-xxxl-4">
            <div class="top row counter-padding">
              <div 
                class="col-4 sebbie-supporter"
                style="padding-right: 5px"
                [title]="'profile.widgets.supporter' | translate"
              >
                <supporter-widget
                  class="supporter-button"
                  [isSupporter]="isSupporter"
                  [isSubscribed]="isSubscribed"
                />
                 @if (!isSubscribed) {
                    <div class="lock">
                      <img src="/assets/images/lock-solid.png" alt="slot"/>
                    </div>
                  }
              </div>
             
              <wide-counter-button
                class="col-4"
                style="padding: 0px 5px"
                [count]="profile.amountOfStreApps"
                [text]="'profile.streapps_posted' | translate"
              />

              <div
                class="col-4 sebbie-rank"
                style="padding-left: 5px"
                (click)="navigateToSebbiePage()"
                [title]="'profile.widgets.sebbie_rang' | translate"
              >
                <div class="counter">
                  <img
                    class="medal-image"
                    src="assets/images/sebbies/ranking-star-solid_white.svg"
                    alt="Sebbies"
                    />
                    <span class="text">{{
                      "profile.widgets.sebbie_rang" | translate
                    }}</span>
                  @if (!isSubscribed) {
                    <div class="lock">
                      <img src="/assets/images/lock-solid.png" alt="slot"/>
                    </div>
                  }
                </div>
              </div>
            </div>

            <sebbie-counter
              class="col-12"
              [monthlySebbiePoints]="profile.monthlySebbiePoints"
              [sebbiePoints]="profile.sebbiePoints"
            ></sebbie-counter>
            <div class="col-12 counter-padding">
              <completed-tasks-widget
                [profile]="profile"
                [isStreapper$]="isStreapper$"
                (click)="navigateToTasksPage()"
              />
            </div>
          </div>
        </div>
      </div>
      <my-streapps />
    </div>
  }
</div>
